module.exports = __webpack_public_path__ + "static/Privacy-65d9accdf7c56fc19f426d8b0fab3b6e.jpg";